<div class="bg-animated-elements">
    <i *ngFor="let icon of ICON_LIST" class="fab {{icon}}"></i>
</div>
<div class="bg-img"></div>
